import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { DriverDetailsData } from "../../drivers.types";
import { ApiRoutesDrivers } from "./../../constants";

export const requestGetDriverById = async (
  driverId: string
): Promise<DriverDetailsData> => {
  return await instance.get(buildUrl(ApiRoutesDrivers.OneDriver, driverId));
};
